import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

// Client do módulo "Budget do Líder de Vendas" — pool PARALELO e SEPARADO do
// budget normal do supervisor. Consome as rotas /budget-lider do backend.
export default class BudgetLiderClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async listar(params = {}) {
    try {
      const cleaned = {};
      Object.entries(params).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== '') cleaned[k] = v;
      });
      return await this.api.get('/budget-lider', { params: cleaned });
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }

  async buscarPorId(id) {
    try {
      return await this.api.get(`/budget-lider/${id}`);
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }

  async criar(payload) {
    try {
      return await this.api.post('/budget-lider', payload);
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }

  async atualizar(id, payload) {
    try {
      return await this.api.put(`/budget-lider/${id}`, payload);
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }

  async excluir(id) {
    try {
      return await this.api.delete(`/budget-lider/${id}`);
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }

  async listarSupervisores() {
    try {
      return await this.api.get('/budget-lider/supervisores');
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }

  async listarRepresentantes(supervisorid) {
    try {
      return await this.api.get(`/budget-lider/supervisores/${supervisorid}/representantes`);
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }

  // Busca de clientes para earmarcar (nome ou código). Falha silenciosa: o
  // autocomplete apenas não retorna resultados se der erro.
  async buscarClientes(termo) {
    return this.api.get('/budget-lider/clientes', { params: { termo } });
  }

  async salvarAlocacoes(id, payload) {
    try {
      return await this.api.put(`/budget-lider/${id}/alocacoes`, payload);
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }

  async dashboard() {
    try {
      return await this.api.get('/budget-lider/dashboard');
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }
}
